import type { QueryRowType } from "@rocicorp/zero";
import { useState } from "react";
import { queries } from "../../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

type Chat = NonNullable<
  NonNullable<QueryRowType<ReturnType<typeof queries.loadPersonalChat>>>["chat"]
>;
type EmptyChat = Pick<
  Chat,
  "id" | "respondingAt" | "lastLoopHeartbeatAt" | "awaitingAction"
>;

export function usePersonalChatContent(
  personalChatId: string | undefined,
  emptyChat: EmptyChat | undefined,
  userId: string
) {
  const [personalChat, result] = useQuery(
    personalChatId
      ? queries.loadPersonalChat({ personalChatId, userId })
      : undefined
  );
  const [optimistic, setOptimistic] = useState<{
    personalChatId: string;
    chat: EmptyChat;
  }>();
  const rememberedChat =
    optimistic?.personalChatId === personalChatId
      ? optimistic?.chat
      : undefined;
  if (personalChatId && emptyChat && !rememberedChat) {
    setOptimistic({ personalChatId, chat: emptyChat });
  } else if (optimistic && optimistic.personalChatId !== personalChatId) {
    setOptimistic(undefined);
  }

  const fallback = emptyChat ?? rememberedChat;
  if (result.type !== "complete" && !fallback) return undefined;
  return personalChat?.chat ?? (fallback && { ...fallback, entries: [] });
}
